function scrollTagsInCard() {
  const tagsContainer = document.querySelectorAll(".article-tags");
  const SPEED_MOUSE = 150;

  if (tagsContainer.length) {
    tagsContainer.forEach((container) => {
      const tags = container.querySelectorAll(".tag");

      if (tags.length >= 4) {
        container.classList.add("scroll");
      }

      container.addEventListener("wheel", (e) => {
        if (e.deltaY !== 0) {
          e.preventDefault();
          container.scrollBy({
            left: e.deltaY > 0 ? SPEED_MOUSE : -SPEED_MOUSE,
            behavior: "smooth",
          });
        }
      }, { passive: false });
    });
  }
}

export default scrollTagsInCard;
